@if (view() === 'firstSubtask' && !hideAddYourFirstSubtask()) {
  <h1>Add your first subtask</h1>
}

@if (view() === 'subtask' || view() === 'firstSubtask') {
  <projects-task-subtask-edit
    [subtaskFormArray]="subtaskFormArray"
    [fromTemplate]="isTemplate"
    [projectId]="projectId"
    [newTask]="newTask"
    [subtaskIndex]="subtaskIndex"
    [editorContainerMaxHeight]="
      view() === 'firstSubtask' ? firstSubtaskEditorContainerMaxHeight : subtaskEditorContainerMaxHeight
    "
    [hideAddYourFirstSubtask]="hideAddYourFirstSubtask"
    [editingTask]="editingTask"
    (changePanel)="changePanel.emit($event)"
    (newTaskBack)="onNewTaskBack()"
    (finish)="onFinish()"
    (newSubtask)="onNewSubtask()"
  ></projects-task-subtask-edit>
}

@if (view() === 'list') {
  @if (newTask) {
    <h1>Add Subtasks</h1>
  }
  <subtask-list
    [class.new-task]="newTask"
    [formArray]="subtaskFormArray"
    [itemBackground]="newTask ? 'light' : 'dark'"
    (subtaskIndexChange)="onEditSubtask($event)"
    (newSubtask)="onNewSubtask()"
  ></subtask-list>
  @if (newTask) {
    <projects-task-subtask-button-footer
      [loadingSave]="loadingSave"
      (back)="onBack()"
      (newSubtask)="onNewSubtask()"
      (finish)="onListFinish()"
    ></projects-task-subtask-button-footer>
  }
}
